"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var Title_1 = __importDefault(require("./styledComponents/Title"));

var DateWrapper_1 = __importDefault(require("./styledComponents/DateWrapper"));

var AsOfDate_meta_1 = require("./AsOfDate.meta");

var Translate_1 = __importStar(require("../Translate/Translate"));

var AsOfDate = function (_super) {
  __extends(AsOfDate, _super);

  function AsOfDate(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = AsOfDate_meta_1.AS_OF_DATE_CATEGORY_KEY;
    _this.componentKey = AsOfDate_meta_1.AS_OF_DATE_COMPONENT_KEY;

    _this.getDate = function (translationContext) {
      var _a = _this.props,
          formatOverride = _a.formatOverride,
          date = _a.date,
          _b = _a.dateFormat,
          dateFormat = _b === void 0 ? 'date' : _b,
          placeholderText = _a.placeholderText;
      var globalFormat = _this.globalConfiguration && _this.globalConfiguration.formats && _this.globalConfiguration.formats[dateFormat];
      var format = formatOverride || globalFormat;

      if (date) {
        if (format) {
          if (!format.locale) {
            format.locale = translationContext && translationContext.culture;
          }

          if (!format.options) {
            format.options = {};
          }

          return ksys_app_template_1.utils.formatter.formatter(format, date);
        }

        return date;
      }

      return placeholderText;
    };

    return _this;
  }

  AsOfDate.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        text = _a.text,
        title = _a.title,
        _b = _a.showBlank,
        showBlank = _b === void 0 ? true : _b;
    var hasTitle = !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(title);
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      var date = _this.getDate(translationContext);

      return (showBlank || date) && react_1.default.createElement(react_1.Fragment, null, hasTitle && react_1.default.createElement(Title_1.default, null, react_1.default.createElement(Translate_1.default, null, title)), react_1.default.createElement(DateWrapper_1.default, null, react_1.default.createElement(Translate_1.default, {
        placeholders: {
          date: date
        }
      }, text)));
    }));
  };

  AsOfDate.defaultProps = {
    text: 'As of {date}'
  };
  AsOfDate = __decorate([mobx_react_1.observer], AsOfDate);
  return AsOfDate;
}(shared_1.ComponentBase);

exports.AsOfDate = AsOfDate;
exports.default = shared_1.InjectedStyledComponent(AsOfDate, AsOfDate_meta_1.AS_OF_DATE_CATEGORY_KEY, AsOfDate_meta_1.AS_OF_DATE_COMPONENT_KEY);